import EmblaCarousel from 'embla-carousel'
import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: { clickPager: 'clickPager' } }
  }

  init() {
    this.onScrollEvent = this.onScrollEvent.bind(this)

    this.newsNb = this.el.querySelectorAll('.news-card').length
    this.progressBar = this.el.querySelector('.news-journal__bottom__counter__progress')
    this.barEl = this.el.querySelector('.news-journal__bottom__counter')
    this.counterEl = this.el.querySelector('.news-journal__bottom__counter__x')
    this.counterIndexEl = this.el.querySelector('.news-journal__current')
    this.pagers = [...this.el.querySelectorAll('.images-block__pager')]
    this.quickSetterProgressBar = gsap.quickSetter(this.progressBar, 'scaleX')
    this.quickSetterCounter = gsap.quickSetter(
      this.counterEl,
      'x',
      'px'
    )

    this.mm = window.matchMedia('(width > 700px)')

    this.onChangeMediaQuery = this.onChangeMediaQuery.bind(this)

    this.mm.addEventListener('change', this.onChangeMediaQuery)

    this.ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this.barEl) {
          this.barWidth = entry.contentRect.width
        }
        if (entry.target === this.counterEl) {
          this.counterWidth = entry.contentRect.width
        }
      }
    })

    this.ro.observe(this.barEl)
    this.ro.observe(this.counterEl)

    const viewportNode = this.el.querySelector('.embla__viewport')

    this.emblaApi = EmblaCarousel(viewportNode, {
      align: 'center',
      active: true,
      breakpoints: { '(width > 700px)': { active: false } }
    })

    this.emblaApi.on('scroll', (e) => {
      const progress = e.scrollProgress()
      const clampedProgress = Math.max(0, Math.min(1, progress))

      this.quickSetterProgressBar(clampedProgress)
      this.quickSetterCounter(clampedProgress * (this.barWidth - this.counterWidth))
    })

    this.emblaApi.on('select', this.onEmblaSelect.bind(this))

    this.emblaApi.on('reInit', () => {
      this.onEmblaSelect()
    })

    window.addEventListener('news-journal-scroll', this.onScrollEvent)
  }

  onChangeMediaQuery() {
    if (this.mm.matches) {
      gsap.set(this.counterEl, { clearProps: 'x' })
      gsap.set(this.progressBar, { clearProps: 'scaleX' })
    }
  }

  onEmblaSelect() {
    const currentSlide = this.emblaApi.selectedScrollSnap()

    for (let i = 0; i < this.pagers.length; i++) {
      this.pagers[i].classList.remove('active')
    }

    this.counterIndexEl.textContent = String(currentSlide + 1).padStart(2, '0')

    this.pagers[currentSlide].classList.add('active')
  }

  onScrollEvent({ detail }) {
    if (!this.mm.matches)
      return

    const {
      target,
      progress
    } = detail

    if (target !== this.el)
      return

    const clampedProgress = Math.max(0, Math.min(1, progress))
    const index = Math.min(Math.round(clampedProgress * this.newsNb), this.newsNb - 1)

    if (index !== this.currentIndex) {
      this.counterIndexEl.textContent = String(index + 1).padStart(2, '0')
      this.currentIndex = index
    }
  }

  clickPager(e) {
    if (!e.currentTarget.classList.contains('active')) {
      this.emblaApi.scrollTo(this.pagers.indexOf(e.currentTarget))
    }
  }

  destroy() {
    window.removeEventListener('news-journal-scroll', this.onScrollEvent)
    this.mm.removeEventListener('change', this.onChangeMediaQuery)
    this.ro.disconnect()
    this.emblaApi.destroy()
  }
}
